import { Injectable, Optional, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { AddLocationPipes } from 'app/shared/models/add-location-pipes';

export interface TritonLocationDialogData {
    isFromCustomerEditor?: boolean;
    customerId?: number;
    locationId?: number;
    editMode?: boolean;
}

@Injectable()
export class AddTritonLocationService {
    @Optional() @Inject(MAT_DIALOG_DATA) public data: TritonLocationDialogData;

    public pipe = new AddLocationPipes();
}
